/**
* Fancybox base script
*/
jQuery(function($) {

    if (typeof $.fancybox === "undefined") {
        console.warn("Fancybox n'est pas chargé !");
        return;
    }

    /**
     * Show modal widget on load, one time / session
     */
    if( $('#modalbox').length ) {
        window.setTimeout(function() {
            $.fancybox.open({
                src: '#modalbox',
                buttons: [
                    "close"
                ],
                animationEffect: "fade",
                transitionDuration: 500,
            });
        }, 800 );
    }

    /**
     * Because Elementor create an auto lightbox on img target
     */
    $('.fancybox-media').each(function() {
        var target = $(this).data('target');
        $(this).on('click', function(e) {
            e.preventDefault();
            $.fancybox.open({
                src: target,
                buttons: [
                    "close"
                ],
                animationEffect: "fade",
                transitionDuration: 500,
            });
            return false;
        });

    });

    $('.fancybox-gallery').fancybox({
        buttons: [
            "close"
        ],
        animationEffect: "fade",
        transitionDuration: 500,
    });

    $('.modal-video, .modal-image').fancybox({
        //src: target,
        buttons: [
            "close"
        ],
        animationEffect: "fade",
        transitionDuration: 500,
    });

    $('.open-popin').each(function() {
        var $a = $(this);
        $a.attr('onclick', null).on('click', function(e) {
            e.preventDefault();

            $.fancybox.open({
                src: $a.attr('href'),
                type: 'iframe',
                buttons : [
                    'close'
                ],
                iframe: {
                    css: {
                        'max-width': '600px',
                        'min-width': '290px',
                    }
                }
            });

            return false;
        });
    });
    
});
